import {
  ATTACH_PARENT_FAIL,
  ATTACH_PARENT_REQUEST,
  ATTACH_PARENT_SUCCESS,
  CLEAR_ERROR_ATTACH_PARENT,
  CLEAR_STATE_ATTACH_PARENT,
} from "../constants/attachParentConstant";
import { axiosInstance } from "../../services/axiosInstance";

// ATTACH PARENT ACTION
export const attachParentAction = (fatherName, motherName, parentEmail, motherEmail) => async (dispatch) => {
  try {
      dispatch({ type: ATTACH_PARENT_REQUEST });

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };

      const { data } = await axiosInstance.put(`/ssb-gpt/attach-parent`,
        {fatherName, motherName, parentEmail, motherEmail},
        config
      );
      dispatch({
        type: ATTACH_PARENT_SUCCESS,
        payload: data,
      });
  } catch (error) {
    dispatch({
      type: ATTACH_PARENT_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

// CLEAR ERROR ACTION FUNCTION
export const clearState = () => async (dispatch) => {
  dispatch({ type: CLEAR_STATE_ATTACH_PARENT });
};

// CLEAR STATE ACTION FUNCTION
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERROR_ATTACH_PARENT });
};
